import { Injectable, inject } from '@angular/core';
import { DfEventData, DfEventService } from '@df/core/service/df-event';
import { Gtm } from '@df/module-gtm/event/gtm.event';
import { GtmDataService } from '@df/module-gtm/service/gtm-data.service';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import './gtm-event-add-to-cart';

@Injectable({
    providedIn: 'root'
})
export class GtmEventAddToCartTrigger {
    /**
     * GTM service
     */
    private gtmService = inject(GtmDlService);

    /**
     * DF events service
     */
    private dfEventService = inject(DfEventService);

    /**
     * GTM basket service
     */
    private gtmDataService = inject(GtmDataService);

    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }

    /**
     * Setup event listener
     */
    private init() {
        this.dfEventService.success(event => {
            if (event.id === 'basketDataChange') {
                const items = event.data.addedItems;
                if (items) {
                    this.dispatch(
                        event,
                        items.map(i => ({ ...this.gtmDataService.basketItemToGtmItem(i.item), qty: i.qty }))
                    );
                }
            }
        });
    }

    /**
     * Dispatch event
     */
    private async dispatch(trigger: DfEventData, changes: Gtm.BasketItem[]) {
        return this.gtmService.dispatch({
            event: 'add_to_cart',
            triggerContext: {
                trigger
            },
            ecommerce: await this.gtmDataService.getEventData(changes)
        });
    }
}
